import { api } from "@/services/api";
import {
  CreateEmployeeRequest,
  UpdateEmployeeRequest,
  CreateSkillRequest,
} from "@/types/employee";

export const employeeService = {
  getEmployees: async (
    slug: string,
    params?: {
      search?: string;
      skill_id?: string;
      page?: number;
      limit?: number;
      area?: string;
      position?: string;
    },
  ) => {
    return api.get("/employees", { params: { slug, ...params } });
  },

  createEmployee: async (data: CreateEmployeeRequest) => {
    return api.post("/employees", data);
  },

  updateEmployee: async (id: string, data: UpdateEmployeeRequest) => {
    return api.put(`/employees/${id}`, data);
  },

  deleteEmployee: async (id: string, slug: string, deleterUserId: string) => {
    return api.delete(`/employees/${id}`, {
      data: { slug, deleterUserId },
    });
  },

  // --- SKILLS ---

  getSkills: async (slug: string) => {
    return api.get("/skills", { params: { slug } });
  },

  createSkill: async (data: CreateSkillRequest) => {
    return api.post("/skills", data);
  },

  deleteSkill: async (id: string, slug: string) => {
    return api.delete(`/skills/${id}`, {
      data: { slug },
    });
  },
};
